import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="bg-brand-cream py-16 md:py-24 px-4" data-id="element-79">
      <div className="max-w-3xl mx-auto text-center" data-id="element-80">
        <FadeIn data-id="element-81">
          <span className="text-brand-amber font-semibold tracking-wider text-sm uppercase mb-4 block" data-id="element-82">
            (sin interrogatorios ni tensión)
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-83">
            Recupera la complicidad con tus hijos en los primeros 10 minutos
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-84">
          <p className="text-lg md:text-xl mb-10 text-brand-gray/80 leading-relaxed max-w-2xl mx-auto" data-id="element-85">
            El método de "Aterrizaje Suave" para padres con custodia compartida
            que quieren eliminar la frialdad del reencuentro y volver a ser el
            referente que sus hijos necesitan.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-86">
          <div className="mb-10 relative max-w-md mx-auto" data-id="element-87">
            <img src="https://cdn.magicpatterns.com/uploads/pVeU8Csnc7uMsx5J3sKFFq/heylloyd-image-1776189443569.png" alt="Rutinas de Conexión Express" className="w-full h-auto rounded-lg shadow-xl" data-id="element-88" />
          </div>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-89">
          <Button onClick={() => window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth'
        })} data-id="element-90">
            👉 DESCARGAR GUÍA AHORA
          </Button>
          <p className="text-sm mt-4 text-brand-gray/60" data-id="element-91">
            Acceso inmediato tras el pago. Formato PDF compatible con cualquier
            dispositivo.
          </p>
        </FadeIn>
      </div>
    </section>;
}